module.exports = __webpack_public_path__ + "static/media/06.Akd.Prog.626538dd.jpg";